var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAwardinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 8.18h-3.84V6.9a.64.64 0 00-.64-.64H10.88a.64.64 0 00-.64.64v1.28H6.4a.64.64 0 00-.64.64c0 3.146.73 5.29 2.173 6.378a3.696 3.696 0 002.518.732 4.481 4.481 0 004.269 3.13h.64v3.84h-3.2c-1.06 0-1.92.86-1.92 1.92v1.28c0 .352.285.64.64.64h10.24a.64.64 0 00.64-.64v-1.28c0-1.06-.86-1.92-1.92-1.92h-3.2v-3.84h.64c2 0 3.7-1.318 4.272-3.13a3.702 3.702 0 002.518-.733c1.44-1.087 2.17-3.231 2.17-6.377a.64.64 0 00-.64-.64zm-5.76 16c.352 0 .64.288.64.64v.64h-8.96v-.64c0-.352.288-.64.64-.64h7.68zM8.688 14.164c-.989-.758-1.549-2.378-1.635-4.704h3.187v5.12l.003.08a2.423 2.423 0 01-1.555-.496zm11.792.416c0 1.763-1.437 3.2-3.2 3.2h-2.56a3.205 3.205 0 01-3.2-3.2V7.54h8.96v7.04zm2.832-.416a2.43 2.43 0 01-1.558.496l.003-.08V9.46h3.187c-.08 2.326-.64 3.946-1.632 4.704z",
    fill: "#fff"
  })));
}

export default SvgAwardinline;